import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import * as THREE from 'three';

const PlaneamentoPaletesForm = () => {
    const [caixasPequenas, setCaixasPequenas] = useState(0);
    const [caixasMedias, setCaixasMedias] = useState(0);
    const [caixasGrandes, setCaixasGrandes] = useState(0);
    const [tipoEnvio, setTipoEnvio] = useState('');
    const [renderer, setRenderer] = useState(null);
    const [paletes, setPaletes] = useState([]);


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!tipoEnvio) {
            alert('Por favor, selecione o tipo de envio.');
            return;
        }

        criarPaletes(caixasPequenas, caixasMedias, caixasGrandes, tipoEnvio);
    };

    const criarPaletes = (pequenas, medias, grandes, tipoEnvio) => {
        const ALTURA_PALETE = tipoEnvio === 'Internacional' ? 204 : 176; // Altura ajustada
        const VOLUME_PALETE = 120 * 80 * ALTURA_PALETE;
        const VOLUME_PEQUENA = 59 * 40 * 18;
        const VOLUME_MEDIA = 59 * 40 * 29;
        const VOLUME_GRANDE = 59 * 79 * 18;

        const paletes = [];
        let totalVolume = (pequenas * VOLUME_PEQUENA) + (medias * VOLUME_MEDIA) + (grandes * VOLUME_GRANDE);

        while (totalVolume > 0) {
            let restante = VOLUME_PALETE;
            const caixasNaPalete = { pequenas: 0, medias: 0, grandes: 0 };

            while (pequenas > 0 && restante >= VOLUME_PEQUENA) {
                caixasNaPalete.pequenas++;
                pequenas--;
                restante -= VOLUME_PEQUENA;
            }

            while (medias > 0 && restante >= VOLUME_MEDIA) {
                caixasNaPalete.medias++;
                medias--;
                restante -= VOLUME_MEDIA;
            }

            while (grandes > 0 && restante >= VOLUME_GRANDE) {
                caixasNaPalete.grandes++;
                grandes--;
                restante -= VOLUME_GRANDE;
            }

            paletes.push(caixasNaPalete);
            totalVolume -= VOLUME_PALETE;
        }

        // Renderiza cada palete
        paletes.forEach((palete, index) => {
            setTimeout(() => {
                renderPalete(palete, index + 1, tipoEnvio);
                //alert(`Palete ${index + 1} renderizada com sucesso!`);
            }, index * 1000); // Adiciona um pequeno atraso
        });

        setPaletes(paletes);

    };

    const renderPalete = (palete, numero, tipoEnvio) => {
        const ALTURA_PALETE = tipoEnvio === 'Internacional' ? 220 : 176;
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(50, 1.5, 0.1, 1000);
        camera.position.set(-1, 1.5, 3); 
        camera.lookAt(0, -1, -20); // Aponta a câmera para o ponto (0, 0, 0) no centro da cena

        const renderer = new THREE.WebGLRenderer();
        renderer.setSize(200, 100);
        renderer.setClearColor(0xffffff, 1); // Define o fundo branco (0xffffff) com opacidade 1
        const containerId = `palete-container-${numero - 1}`; // Ajuste para alinhar com o index usado no JSX
        let container = document.getElementById(containerId);

        if (!container) {
            container = document.createElement('div');
            container.id = containerId;
            container.style.marginBottom = '20px';
            document.getElementById('threejs-container').appendChild(container);
        }

        container.innerHTML = ''; // Limpa renderizações anteriores
        container.appendChild(renderer.domElement);

        const light = new THREE.DirectionalLight(0xffffff, 1);
        light.position.set(10, 10, 10).normalize();
        scene.add(light);

        const palletMaterial = new THREE.MeshLambertMaterial({ color: 0x8B4513 });
        const boxMaterials = {
            pequena: new THREE.MeshLambertMaterial({ color: 0x0bff58 }),
            media: new THREE.MeshLambertMaterial({ color: 0xFCC527 }),
            grande: new THREE.MeshLambertMaterial({ color: 0xf80606 }),
        };

        const palletGeometry = new THREE.BoxGeometry(1.2, 0.1, 0.8);
        const pallet = new THREE.Mesh(palletGeometry, palletMaterial);
        scene.add(pallet);

        let alturaAtual = 0.05;
        let currentX = -0.6; // Início na borda esquerda da palete (largura/2)
        let currentZ = -0.4; // Início na borda traseira da palete (profundidade/2)
        let currentMaxHeight = 0;

        const addBox = (width, depth, height, quantidade, material) => {
            for (let i = 0; i < quantidade; i++) {
                const boxGeometry = new THREE.BoxGeometry(width, height, depth);
                const box = new THREE.Mesh(boxGeometry, material);

                // Adiciona as arestas em azul
                const edges = new THREE.EdgesGeometry(boxGeometry);
                const lineMaterial = new THREE.LineBasicMaterial({ color: 0x0000ff }); // Azul
                const wireframe = new THREE.LineSegments(edges, lineMaterial);
                box.add(wireframe);
                // Se o espaço na largura for excedido, pula para a próxima fileira
                if (currentX + width > 0.6) {
                    currentX = -0.6; // Reinicia na borda esquerda
                    currentZ += depth; // Avança na profundidade
                }

                // Se o espaço na profundidade for excedido, empilha na altura
                if (currentZ + depth > 0.4) {
                    currentZ = -0.4; // Reinicia na borda traseira
                    alturaAtual += currentMaxHeight; // Empilha acima da camada atual
                    currentMaxHeight = 0; // Reseta a altura máxima da nova camada
                }

                // Posiciona a caixa na coordenada calculada
                box.position.set(
                    currentX + width / 2,
                    alturaAtual + height / 2,
                    currentZ + depth / 2
                );

                // Atualiza posição para a próxima caixa
                currentX += width;
                currentMaxHeight = Math.max(currentMaxHeight, height);

                pallet.add(box);
            }
        };

        addBox(0.59, 0.4, 0.18, palete.pequenas, boxMaterials.pequena);
        addBox(0.59, 0.4, 0.29, palete.medias, boxMaterials.media);
        addBox(0.59, 0.79, 0.18, palete.grandes, boxMaterials.grande);

        const animate = () => {
            requestAnimationFrame(animate);
            pallet.rotation.y += 0.01;
            renderer.render(scene, camera);
        };

        animate();
        setRenderer(renderer);
    };

    useEffect(() => {
        return () => {
            if (renderer) {
                renderer.dispose(); // Limpa o renderer ao desmontar
            }
        };
    }, [renderer]);

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Planeamento de Paletes</Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{ mb: 3 }}>
                <TextField
                    label="Número de Caixas Pequenas"
                    type="number"
                    value={caixasPequenas}
                    onChange={(e) => setCaixasPequenas(parseInt(e.target.value) || 0)}
                    fullWidth
                    sx={{ mb: 2 }}
                />

                <TextField
                    label="Número de Caixas Médias"
                    type="number"
                    value={caixasMedias}
                    onChange={(e) => setCaixasMedias(parseInt(e.target.value) || 0)}
                    fullWidth
                    sx={{ mb: 2 }}
                />

                <TextField
                    label="Número de Caixas Grandes"
                    type="number"
                    value={caixasGrandes}
                    onChange={(e) => setCaixasGrandes(parseInt(e.target.value) || 0)}
                    fullWidth
                    sx={{ mb: 2 }}
                />

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Tipo de Envio</InputLabel>
                    <Select
                        value={tipoEnvio}
                        onChange={(e) => setTipoEnvio(e.target.value)}
                    >
                        <MenuItem value="Nacional">Nacional</MenuItem>
                        <MenuItem value="Internacional">Internacional</MenuItem>
                    </Select>
                </FormControl>

                <Button type="submit" variant="contained" color="primary" fullWidth>
                    Calcular e Renderizar Paletes
                </Button>
            </Box>

            <Box id="threejs-container" sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '20px',
                    justifyItems: 'center',
                }}>
                    {paletes.map((_, index) => (
                        <Box key={index} sx={{
                            textAlign: 'center',
                            border: '1px solid #ccc',
                            padding: '10px',
                            borderRadius: '5px',
                        }}>
                            <Typography variant="subtitle1" sx={{ marginBottom: '10px' }}>
                                Palete {index + 1}
                            </Typography>
                            <Box id={`palete-container-${index}`} sx={{
                                width: '300px',
                                height: '200px',
                                border: '1px solid #000',
                                background: '#fff'
                            }}>
                                {/* O renderizador THREE.js será anexado aqui */}
                            </Box>
                        </Box>
                    ))}
                </Box>
        </Box>
    );
};

export default PlaneamentoPaletesForm;
